(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["declock-brand-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('declock-brand-carousel')) {
    customElements.define('declock-brand-carousel', class extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.declock-brand-strip__scroller');
        this.buttons = [...this.querySelectorAll('.declock-brand-strip__arrow')];
        if (!this.scroller || !this.buttons.length) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.queueUpdate = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.buttons.forEach(button => {
          button.addEventListener('click', () => {
            if (button.getAttribute('aria-disabled') === 'true') return;
            this.move(Number(button.dataset.direction));
          }, options);
        });
        this.scroller.addEventListener('scroll', this.queueUpdate, { ...options, passive: true });
        this.scroller.addEventListener('keydown', event => {
          if (event.target !== this.scroller) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') {
            const rtl = getComputedStyle(this.scroller).direction === 'rtl';
            this.scroller.scrollTo({ left: event.key === 'Home' ? 0 : this.scroller.scrollWidth * (rtl ? -1 : 1), behavior: this.motion() });
          } else {
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.resizeObserver = new ResizeObserver(this.queueUpdate);
        this.resizeObserver.observe(this.scroller);
        [...this.scroller.children].forEach(item => this.resizeObserver.observe(item));
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('.declock-brand-strip__link');
          if (item) item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        }, options);
        this.update();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      motion() {
        return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      }

      move(direction) {
        this.scroller.scrollBy({ left: direction * this.scroller.clientWidth * 0.75, behavior: this.motion() });
      }

      update() {
        const max = this.scroller.scrollWidth - this.scroller.clientWidth;
        const position = Math.abs(this.scroller.scrollLeft);
        const rtl = getComputedStyle(this.scroller).direction === 'rtl';
        this.toggleAttribute('data-overflow', max > 2);
        this.buttons.forEach(button => {
          const towardsStart = (Number(button.dataset.direction) < 0) !== rtl;
          button.setAttribute('aria-disabled', String(max <= 2 || (towardsStart ? position <= 2 : position >= max - 2)));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  let lvMobileSearchScrollIntentAt = 0;
  const markLvMobileSearchScrollIntent = () => {
    lvMobileSearchScrollIntentAt = Date.now();
  };

  window.addEventListener('touchmove', markLvMobileSearchScrollIntent, { passive: true });
  window.addEventListener('wheel', markLvMobileSearchScrollIntent, { passive: true });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (this.header) {
        this.header.classList.toggle('section-header--lv-product', this.classList.contains('lv-header-wrapper--product'));
      }
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.onMobileSearchToggle = this.onMobileSearchToggle.bind(this);
      this.onMenuDrawerToggle = this.closeMobileSearchBar.bind(this);
      this.onContactToggle = this.openContactPanel.bind(this);
      this.onContactClose = this.closeContactPanel.bind(this);
      this.onContactKeydown = this.onContactKeydown.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.mobileSearchToggle = this.querySelector('[data-lv-mobile-search-toggle]');
      if (this.mobileSearchToggle) {
        this.mobileSearchToggle.addEventListener('click', this.onMobileSearchToggle);
      }

      this.menuDrawerToggle = this.querySelector('#Details-menu-drawer-container > summary');
      if (this.menuDrawerToggle) {
        this.menuDrawerToggle.addEventListener('click', this.onMenuDrawerToggle);
      }

      this.contactToggle = this.querySelector('[data-lv-contact-toggle]');
      this.contactPanel = this.querySelector('[data-lv-contact-panel]');
      this.contactDialog = this.querySelector('.lv-contact-panel__dialog');
      this.contactCloseButtons = this.querySelectorAll('[data-lv-contact-close]');

      if (this.contactToggle && this.contactPanel) {
        this.contactToggle.addEventListener('click', this.onContactToggle);
        this.contactCloseButtons.forEach((button) => button.addEventListener('click', this.onContactClose));
        document.addEventListener('keyup', this.onContactKeydown);
      }

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.mobileSearchToggle) {
        this.mobileSearchToggle.removeEventListener('click', this.onMobileSearchToggle);
      }
      if (this.menuDrawerToggle) {
        this.menuDrawerToggle.removeEventListener('click', this.onMenuDrawerToggle);
      }
      if (this.contactToggle) {
        this.contactToggle.removeEventListener('click', this.onContactToggle);
      }
      if (this.contactCloseButtons) {
        this.contactCloseButtons.forEach((button) => button.removeEventListener('click', this.onContactClose));
      }
      document.removeEventListener('keyup', this.onContactKeydown);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isMobileHeader = window.matchMedia('(max-width: 749px)').matches;
      const isMobileHomeHeader =
        isMobileHeader && this.classList.contains('lv-header-wrapper--home');
      const isMobileProductHeader =
        isMobileHeader && this.classList.contains('lv-header-wrapper--product');
      const isMobileOverlayHeader = isMobileHomeHeader || isMobileProductHeader;
      const mobileSearchOpenedAt = Number(this.dataset.lvMobileSearchOpenedAt || 0);
      const mobileSearchCanClose = Date.now() - mobileSearchOpenedAt > 220;
      const mobileSearchUserScrolled = Date.now() - lvMobileSearchScrollIntentAt < 700;

      if (
        isMobileHeader &&
        this.classList.contains('lv-search-open') &&
        mobileSearchCanClose &&
        mobileSearchUserScrolled &&
        Math.abs(scrollTop - this.currentScrollTop) > 2
      ) {
        this.closeMobileSearchBar();
      }

      if (Array.from(this.predictiveSearches).some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (isMobileOverlayHeader) {
        if (scrollTop > 8) {
          this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky');
          this.header.classList.remove('shopify-section-header-hidden');
        } else {
          this.header.classList.remove(
            'scrolled-past-header',
            'shopify-section-header-hidden',
            'shopify-section-header-sticky',
            'animate'
          );
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }

    openContactPanel(event) {
      event.preventDefault();
      this.closeMobileSearchBar();
      this.closeMobileMenuDrawer();

      this.contactPanel.classList.add('is-open');
      this.contactPanel.setAttribute('aria-hidden', 'false');
      this.contactToggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');

      requestAnimationFrame(() => {
        try {
          this.contactDialog.focus({ preventScroll: true });
        } catch (error) {
          this.contactDialog.focus();
        }
      });
    }

    closeContactPanel(event) {
      if (event) event.preventDefault();
      if (!this.contactPanel) return;

      this.contactPanel.classList.remove('is-open');
      this.contactPanel.setAttribute('aria-hidden', 'true');
      this.contactToggle?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
      this.contactToggle?.focus?.({ preventScroll: true });
    }

    onContactKeydown(event) {
      if (event.code !== 'Escape') return;
      if (!this.contactPanel?.classList.contains('is-open')) return;

      this.closeContactPanel(event);
    }

    onMobileSearchToggle(event) {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      event.preventDefault();

      if (this.classList.contains('lv-search-open')) {
        this.closeMobileSearchBar();
        return;
      }

      if (this.closeMobileMenuDrawer()) {
        window.setTimeout(() => this.openMobileSearchBar(event.currentTarget), 430);
        return;
      }

      this.openMobileSearchBar(event.currentTarget);
    }

    openMobileSearchBar(toggle = this.mobileSearchToggle) {
      this.classList.add('lv-search-open');
      this.dataset.lvMobileSearchOpenedAt = Date.now().toString();

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
      }

      const mobileSearchDetails = this.querySelector('.lv-mobile-home-search details');
      if (mobileSearchDetails) mobileSearchDetails.setAttribute('open', '');

      const mobileSearchInput = this.querySelector('.lv-mobile-home-search .search__input');
      if (mobileSearchInput) {
        requestAnimationFrame(() => {
          try {
            mobileSearchInput.focus({ preventScroll: true });
          } catch (error) {
            mobileSearchInput.focus();
          }
        });
      }
    }

    closeMobileMenuDrawer() {
      const menuDetails = this.querySelector('#Details-menu-drawer-container');
      if (!menuDetails || !menuDetails.hasAttribute('open')) return false;

      const menuSummary = menuDetails.querySelector('summary');
      const headerDrawer = menuDetails.closest('header-drawer');

      if (headerDrawer && typeof headerDrawer.closeMenuDrawer === 'function' && menuSummary) {
        headerDrawer.closeMenuDrawer(new Event('click'), menuSummary);
      } else {
        menuDetails.removeAttribute('open');
        menuDetails.classList.remove('menu-opening');
        menuDetails.querySelectorAll('details').forEach((details) => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        });
        document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile', 'overflow-hidden-desktop');
        this.header?.classList.remove('menu-open');
      }

      if (menuSummary) {
        menuSummary.setAttribute('aria-expanded', 'false');
      }

      return true;
    }

    closeMobileSearchBar() {
      this.classList.remove('lv-search-open');
      delete this.dataset.lvMobileSearchOpenedAt;

      if (this.mobileSearchToggle) {
        this.mobileSearchToggle.setAttribute('aria-expanded', 'false');
      }

      const mobileSearchModal = this.querySelector('.lv-mobile-home-search details-modal');
      if (mobileSearchModal && typeof mobileSearchModal.close === 'function') {
        mobileSearchModal.close(false);
        return;
      }

      const mobileSearchDetails = this.querySelector('.lv-mobile-home-search details');
      if (mobileSearchDetails) mobileSearchDetails.removeAttribute('open');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('click', (event) => {
    const menuToggle = event.target.closest('#Details-menu-drawer-container > summary');

    if (!menuToggle || !window.matchMedia('(max-width: 749px)').matches) {
      return;
    }

    const wrapper = menuToggle.closest('.lv-header-wrapper');
    if (!wrapper) return;

    wrapper.classList.remove('lv-search-open');
    delete wrapper.dataset.lvMobileSearchOpenedAt;

    const toggle = wrapper.querySelector('[data-lv-mobile-search-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    const mobileSearchModal = wrapper.querySelector('.lv-mobile-home-search details-modal');
    if (mobileSearchModal && typeof mobileSearchModal.close === 'function') {
      mobileSearchModal.close(false);
      return;
    }

    const mobileSearchDetails = wrapper.querySelector('.lv-mobile-home-search details');
    if (mobileSearchDetails) mobileSearchDetails.removeAttribute('open');
  });

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-lv-mobile-search-toggle]');

    if (
      !toggle ||
      event.defaultPrevented ||
      !window.matchMedia('(max-width: 749px)').matches
    ) {
      return;
    }

    const wrapper = toggle.closest('.lv-header-wrapper');
    if (!wrapper) return;

    event.preventDefault();

    if (
      !wrapper.classList.contains('lv-search-open') &&
      typeof wrapper.closeMobileMenuDrawer === 'function' &&
      wrapper.closeMobileMenuDrawer()
    ) {
      window.setTimeout(() => {
        if (typeof wrapper.openMobileSearchBar === 'function') {
          wrapper.openMobileSearchBar(toggle);
        }
      }, 430);
      return;
    }

    const isOpen = wrapper.classList.toggle('lv-search-open');
    if (isOpen) {
      wrapper.dataset.lvMobileSearchOpenedAt = Date.now().toString();
    } else {
      delete wrapper.dataset.lvMobileSearchOpenedAt;
    }
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    const mobileSearchModal = wrapper.querySelector('.lv-mobile-home-search details-modal');
    if (!isOpen && mobileSearchModal && typeof mobileSearchModal.close === 'function') {
      mobileSearchModal.close(false);
      return;
    }

    const mobileSearchDetails = wrapper.querySelector('.lv-mobile-home-search details');
    if (mobileSearchDetails) {
      if (isOpen) {
        mobileSearchDetails.setAttribute('open', '');
      } else {
        mobileSearchDetails.removeAttribute('open');
      }
    }

    if (isOpen) {
      const mobileSearchInput = wrapper.querySelector('.lv-mobile-home-search .search__input');
      if (mobileSearchInput) {
        requestAnimationFrame(() => {
          try {
            mobileSearchInput.focus({ preventScroll: true });
          } catch (error) {
            mobileSearchInput.focus();
          }
        });
      }
    }
  });

  window.addEventListener(
    'scroll',
    () => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      document.querySelectorAll('.lv-header-wrapper.lv-search-open').forEach((wrapper) => {
        const mobileSearchOpenedAt = Number(wrapper.dataset.lvMobileSearchOpenedAt || 0);
        const mobileSearchUserScrolled = Date.now() - lvMobileSearchScrollIntentAt < 700;

        if (Date.now() - mobileSearchOpenedAt <= 220) return;
        if (!mobileSearchUserScrolled) return;

        wrapper.classList.remove('lv-search-open');
        delete wrapper.dataset.lvMobileSearchOpenedAt;

        const toggle = wrapper.querySelector('[data-lv-mobile-search-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');

        const mobileSearchModal = wrapper.querySelector('.lv-mobile-home-search details-modal');
        if (mobileSearchModal && typeof mobileSearchModal.close === 'function') {
          mobileSearchModal.close(false);
          return;
        }

        const mobileSearchDetails = wrapper.querySelector('.lv-mobile-home-search details');
        if (mobileSearchDetails) mobileSearchDetails.removeAttribute('open');
      });
    },
    { passive: true }
  );

  } catch(e) { console.error(e); }
})();
})();
